import { Reveal } from "./Reveal";
import { useLang } from "@/i18n";

export const About = () => {
  const { t } = useLang();
  const a = t.about;
  return (
    <section
      id="ueber"
      className="relative border-t border-[var(--line)] bg-[var(--bg-0)] py-24 md:py-36"
      data-testid="about-section"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="font-mono2 text-[11px] tracking-[0.4em] uppercase text-[var(--txt-mut)]">
                {a.label}
              </span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-heading font-bold tracking-tight text-4xl md:text-5xl lg:text-6xl mt-6 leading-[0.95]">
                {a.headingLines[0]}
                <br />
                {a.headingLines[1]}
                <br />
                <span className="text-[var(--accent)]">{a.headingLines[2]}</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="font-body font-light text-[var(--txt-dim)] text-base md:text-lg leading-relaxed mt-8 max-w-md">
                {a.paragraph}
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pl-10" data-testid="timeline">
            <div className="relative">
              <div className="absolute left-0 top-2 bottom-2 w-px bg-[var(--line)]" />
              {a.timeline.map((item, i) => (
                <Reveal key={item.year} delay={i * 0.12}>
                  <div className="relative pl-10 md:pl-14 pb-16 md:pb-24 group">
                    <span className="absolute left-0 top-2 -translate-x-1/2 h-2.5 w-2.5 rounded-full bg-[var(--txt-mut)] group-hover:bg-[var(--accent)] transition-colors duration-500" />
                    <div className="font-mono2 text-sm text-[var(--accent)] tracking-widest">
                      {item.year}
                    </div>
                    <h3 className="font-heading font-bold text-xl md:text-2xl mt-2">
                      {item.title}
                    </h3>
                    <p className="font-body font-light text-[var(--txt-dim)] text-base leading-relaxed mt-3 max-w-xl">
                      {item.text}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
